import { render, staticRenderFns } from "./MailingViewBranch.vue?vue&type=template&id=3c1e88d0&"
import script from "./MailingViewBranch.vue?vue&type=script&lang=js&"
export * from "./MailingViewBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports